module.exports = __webpack_public_path__ + "img/icon93.c7857715.png";